import { Pipe, PipeTransform } from '@angular/core';
import { Food } from '../domains/food';

@Pipe({name: 'foodsEmpty'})
export class FoodsEmptyPipe implements PipeTransform {
  transform(foods: Food[]) {
    return foods.length === 0 || foods.every(food => !food.title);
  }
}
